import { __exportAll } from "../../_virtual/_rolldown/runtime.js";
//#region src/redux/transient/reducers.ts
var reducers_exports = /* @__PURE__ */ __exportAll({ updateTransient: () => updateTransient });
var updateTransient = (state, { payload }) => {
	const { transients: newTransients } = payload;
	if (newTransients) newTransients.forEach((newTransient) => {
		const existingIndex = state?.transients?.findIndex((existingTransient) => existingTransient.key === newTransient.key);
		if (existingIndex !== -1) state.transients[Number(existingIndex)] = newTransient;
		else state?.transients?.push(newTransient);
	});
};
//#endregion
export { reducers_exports, updateTransient };

//# sourceMappingURL=reducers.js.map